import { useApp } from '../context/AppContext';
import StatusBadge from '../components/StatusBadge';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Star, Plus, MapPin, Clock, Shield } from 'lucide-react';

export default function Technicians() {
  const { technicians } = useApp();

  return (
    <div className="space-y-5" data-testid="technicians-page">
      <div className="flex items-end justify-between gap-4 flex-wrap">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-slate-500 font-semibold">Technicians</div>
          <h1 className="mt-1 text-3xl font-semibold text-slate-900 tracking-tight">Field team</h1>
          <p className="mt-1 text-sm text-slate-500">{technicians.length} active technicians across 3 service areas</p>
        </div>
        <Button className="bg-[#0052CC] hover:bg-[#0043A6] h-9"><Plus className="h-4 w-4 mr-2" />Add Technician</Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {technicians.map((t) => (
          <Card key={t.id} className="p-5 border-slate-200 shadow-sm" data-testid={`tech-card-${t.id}`}>
            <div className="flex items-start gap-4">
              <div className="h-14 w-14 rounded-lg bg-slate-900 text-white text-base font-semibold flex items-center justify-center">{t.initials}</div>
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-semibold text-slate-900">{t.name}</div>
                    <div className="text-xs text-slate-500">{t.role}</div>
                  </div>
                  <StatusBadge status={t.availability === 'Available' ? 'healthy' : t.availability === 'Off Today' ? 'offline' : 'warning'}>{t.availability}</StatusBadge>
                </div>
                <div className="mt-2 flex items-center gap-1 text-xs text-amber-600 font-medium">
                  <Star className="h-3.5 w-3.5 fill-amber-400 stroke-amber-500" /> <span className="font-mono">{t.rating}</span>
                  <span className="text-slate-400 ml-2">customer rating</span>
                </div>
              </div>
            </div>

            <div className="mt-4 grid grid-cols-3 gap-2 text-center">
              <Metric label="Active" value={t.activeTickets} />
              <Metric label="This Mo." value={t.completedThisMonth} />
              <Metric label="Avg Resp" value={`${t.avgResponseHrs}h`} />
            </div>

            <div className="mt-4 space-y-1.5 text-xs text-slate-600">
              <div className="flex items-center gap-1.5"><MapPin className="h-3 w-3" /> {t.serviceArea}</div>
              <div className="flex items-center gap-1.5"><Shield className="h-3 w-3" /> {t.certifications.join(' · ')}</div>
            </div>

            <div className="mt-4 flex gap-2">
              <Button variant="outline" className="flex-1 h-8 text-xs">View Schedule</Button>
              <Button variant="outline" className="flex-1 h-8 text-xs">Assign Job</Button>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}

function Metric({ label, value }) {
  return (
    <div className="rounded-md bg-slate-50 border border-slate-200 py-2">
      <div className="font-mono text-lg font-semibold text-slate-900 leading-none">{value}</div>
      <div className="text-[10px] uppercase tracking-wider text-slate-500 mt-1">{label}</div>
    </div>
  );
}
